import React from "react";
import mapboxgl from "mapbox-gl";
import { renderToString } from "react-dom/server";
import "mapbox-gl/dist/mapbox-gl.css";
import { Row, Col } from "react-bootstrap"
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css"; //mapbox-gl/dist/mapbox-gl.css

mapboxgl.accessToken =
  "pk.eyJ1IjoiaGljYXJ1cyIsImEiOiJja2kyYThzenEwOGs3MnJtaWdkYnJkbGswIn0._ik3moCiiaseVdjpoSI1Pw";
const style_url = "mapbox://styles/hicarus/ckdqu5xo409xb19o149m5oc35/draft";
const default_image = "https://firebasestorage.googleapis.com/v0/b/gto-mkt-dev.appspot.com/o/location.jpeg?alt=media&token=140223c7-ceda-4618-ba74-5750a3be2dd7"

function POSPreview(props) {

  const client = props
  return (
    <div className="m-2 p-3 ">
      <Row>
        <Col xs={4}>
          <img src={client.image ?? default_image} alt={client.name} width="100%" className="rounded" />
        </Col>
        <Col>

          <h6>
            <span
              className="pointer-hover"

            >{client.name}</span>
            <span className="text-muted">, {client.address}</span>
          </h6>
          <span className="row">
            <div className="col-2">
              <hr
                style={{
                  height: "3px",
                  width: "30px",
                  borderTop: `5px solid ${client.user_color || "#adadad"}`,
                }}
              />
            </div>
            <div className="col-8" style={{ paddingTop: "5px" }}>
              <strong>{client.state}</strong>
            </div>
          </span>
          {client.contact && <>
            <label><strong>Contact: </strong></label>
            {client.contact}, <span className="ml-2 text-muted">
              {client.phone}, {client.email}
            </span></>}
        </Col>

      </Row>
    </div>
  )
}

function PopUpMarker(props) {
  // const [agent, setAgent] = useState(null);
  const trace = props.trace;
  const [agent] = props.extra.agents.filter((agent) => agent.uid === props.uid);
  const default_tasks = ["checkin", "checkout"];
  const [task] = props.extra.tasks.filter(task => task.uid === trace.task_id)
  return (
    <div className="container-fluid p-4">
      <div className="row">
        <div className="col-6">
          <label>Agent Image</label>
          <div
            className="image-input image-input-outline"
            id="kt_profile_avatar"
          >
            <div
              className="image-input-wrapper"
              style={{
                backgroundImage: `url(${agent.photoURL})`,
              }}
            ></div>
          </div>
        </div>
        <div className="col-6">
          <label>Agent</label>
          <h5>{agent.name}</h5>
          <br />
          <label>
            {default_tasks.includes(trace.task_id) ? (
              <b>Action</b>
            ) : (
              <b>Task</b>

            )}
          </label>
          {default_tasks.includes(trace.task_id) ? (
            <h4>{trace.task_id === "checkin" ? "Check-in" : "Check-out"}</h4>
          ) : (
            <>
              <h4>{task?.name}</h4>
            </>
          )}
          <small>
            {new Date(props.trace.write._seconds * 1000).toLocaleString()}
          </small>
        </div>
      </div>
    </div>
  );
}
class Map extends React.Component {
  container = null;
  map = null;
  main_marker = new mapboxgl.Marker();
  markers = [];
  pos = [];
  constructor(props) {
    super(props);
    this.add3DStyle = this.add3DStyle.bind(this);
    this.addTraces = this.addTraces.bind(this);
    this.addPayments = this.addPayments.bind(this);
    this.removeTraces = this.removeTraces.bind(this);
    this.removeMarkers = this.removeMarkers.bind(this)
    this.addGeoSearch = this.addGeoSearch.bind(this);
    this.addPOS = this.addPOS.bind(this);
    this.state = {
      traces: props.traces,
      pos: props.pos

    };
  }
  componentDidUpdate() {
    this.removeMarkers()
    this.addPOS()
    this.map.resize();

    if (this.state?.traces?.length !== this.props?.traces?.length) {
      this.setState({ traces: this.props.traces },
        () => {
          this.removeTraces();
          this.addTraces();
        }
      );
    }
  }
  componentDidMount() {
    const { props } = this;
    const l = props?.location || {};
    const center = l.uid
      ? [l.coordinates.longitude, l.coordinates.latitude]
      : [-95.09984048084924, 30.217816167216384];
    this.map = new mapboxgl.Map({
      container: this.container,
      style: style_url,
      center: center,
      pitch: props.preview ? 30 : 0,
      zoom: props.zoom || 1.35,
    });
    this.map.on("load", () => {
      this.add3DStyle();
      this.addGeoSearch();
      this.addTraces();
      this.addPayments();

      this.addPOS();
      this.map.resize();
      this.map.addControl(new mapboxgl.NavigationControl());
      // this.map.addControl(new mapboxgl.FullscreenControl());
      this.map.resize();

      this.map.on("click", (e) => {
        this.map.resize();

        const { lng, lat } = e.lngLat;
        //console.log({ lng, lat })
        this.map.flyTo({
          center: [lng, lat],
        });
        if (!props.preview) {
          this.main_marker.setLngLat([lng, lat]);
        }
        props.controller &&
          props.controller({
            latitude: lat,
            longitude: lng,
          });
      });

    });
  }
  addPayments() {

    const { props } = this
    if (!props?.payments?.length) {
      return;
    }
    const [center] = props.payments
    const { coordinates } = center

    this.map.flyTo({
      center: [coordinates.longitude ?? coordinates.longitud, coordinates.latitude ?? coordinates.latitud],
    });
    for (const pos of props.payments) {
      pos.payment = true
      const popup = new mapboxgl.Popup({ offset: 25 })
        .setMaxWidth("375px")
        .setHTML(
          renderToString(
            <POSPreview {...pos} />
          )
        );
      const marker = new mapboxgl.Marker({ color: "green" });
      this.markers.push(marker);
      const { longitude, longitud, latitude, latitud } = pos.coordinates
      marker
        .setLngLat([longitude ?? longitud, latitude ?? latitud])
        .addTo(this.map)
        .setPopup(popup);
    }

  }
  addPOS() {

    const { props } = this
    if (!props?.pos?.length) {
      return;
    }
    const [default_pos] = props.pos
    const { longitude, longitud, latitude, latitud } = default_pos.coordinates

    this.map.flyTo({
      center: [longitude ?? longitud, latitude ?? latitud],
      zoom: 7
    });

    for (const pos of props.pos) {
      const popup = new mapboxgl.Popup({ offset: 25 })
        .setMaxWidth("400px")
        .setHTML(
          renderToString(
            <POSPreview {...pos} />
          )
        );
      const marker = new mapboxgl.Marker({ color: pos.visited ? "green" : "red" });
      this.markers.push(marker);
      const { longitude, longitud, latitude, latitud } = pos.coordinates
      marker
        .setLngLat([longitude ?? longitud, latitude ?? latitud])
        .addTo(this.map)
        .setPopup(popup);
    }

  }
  add3DStyle() {
    this.map.resize();

    const { props } = this;
    const l = props.location || {};
    const center = l.uid
      ? [l.coordinates.longitude, l.coordinates.latitude]
      : [0, 0];
    let layers = this.map.getStyle().layers;
    if (!l.coordinates) {
      props.controller &&
        props.controller({
          latitude: 0,
          longitude: 0,
        });
    }
    let labelLayerId;
    for (let i = 0; i < layers.length; i++) {
      if (layers[i].type === "symbol" && layers[i].layout["text-field"]) {
        labelLayerId = layers[i].id;
        break;
      }
    }

    if (!props.preview || props.mainMarker) {
      this.main_marker.setLngLat(center).addTo(this.map);
    }
    this.map.addLayer(
      {
        id: "3d-buildings",
        source: "composite",
        "source-layer": "building",
        filter: ["==", "extrude", "true"],
        type: "fill-extrusion",
        minzoom: 15,
        paint: {
          "fill-extrusion-color": "#aaa",
          "fill-extrusion-height": [
            "interpolate",
            ["linear"],
            ["zoom"],
            15,
            0,
            15.05,
            ["get", "height"],
          ],
          "fill-extrusion-base": [
            "interpolate",
            ["linear"],
            ["zoom"],
            15,
            0,
            15.05,
            ["get", "min_height"],
          ],
          "fill-extrusion-opacity": 0.6,
        },
      },
      labelLayerId
    );
    this.map.addSource("single-point", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [],
      },
    });
  }
  addGeoSearch() {
    this.map.resize();

    const { props } = this;

    const geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      marker: false,
      placeholder: "Search for places",
      proximity: {},
    });

    if (!props.preview) {
      this.map.addControl(geocoder);
      geocoder.on("result", (e) => {
        const [lng, lat] = e.result.geometry.coordinates;
        props.controller &&
          props.controller({
            latitude: lat,
            longitude: lng,
          });
        props.setContext && props.setContext(e.result.context, e.result)
        this.main_marker.setLngLat(e.result.geometry.coordinates);
      });
    }
  }
  removeMarkers() {
    if (this.markers.length) {
      for (let i = this.markers.length - 1; i >= 0; i--) {
        this.markers[i].remove();
      }
    }
  }
  removeTraces() {

    this.map.removeLayer("t-lines");
    this.map.removeSource("traces-lines");
  }
  addTraces() {
    this.map.resize();

    const { props } = this;
    if (!this.state.traces) {
      return
    }
    const traces = this.state.traces
      .filter((user) => user.length)
      .map((user) => {
        const [info] = user;
        const color = info.color
        const uid = info.uid || info.user_id;
        const lines = user.map((trace) => {
          const { latitude, longitude } = trace.coordinates;
          const coordinates = [Number(longitude), Number(latitude)];
          if (trace.type === "task") {
            const popup = new mapboxgl.Popup({ offset: 25 })
              .setMaxWidth("350px")
              .setHTML(
                renderToString(
                  <PopUpMarker uid={uid} extra={props.extra} trace={trace} />
                )
              );
            const marker = new mapboxgl.Marker({
              color: color,
            });
            this.markers.push(marker);
            marker
              .setLngLat(coordinates)
              .addTo(this.map)
              .setPopup(popup);
          }
          return coordinates;
        });

        return {
          type: "Feature",
          properties: {
            color: color,
            description: uid,
            icon: "theatre",
          },
          geometry: {
            type: "LineString",
            coordinates: lines,
          },
        };
      });

    this.map.addSource("traces-lines", {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: traces,
      },
    });
    this.map.addLayer({
      id: "t-lines",
      type: "line",
      source: "traces-lines",
      paint: {
        "line-width": 5,
        "line-color": ["get", "color"],
      },
    });

    this.map.on("click", "t-lines", async (e) => {
      // let coordinates = e.features[0].geometry.coordinates.slice();
      // const uid = e.features[0].properties.description;

      // Axios.get(
      //   `https://us-central1-bpo-dist-dev.cloudfunctions.net/api/v2/users/find/${uid}`
      // ).then(({ data }) => {
      //   const user = data.payload;
      //   while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      //     coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
      //   }
      //   new mapboxgl.Popup()
      //     .setLngLat(coordinates)
      //     .setHTML(renderToString(<Description user={user} />))
      //     .setMaxWidth("350px")
      //     .addTo(this.map);
      // });
    });
    this.map.on("mouseenter", "t-lines", () => {
      this.map.getCanvas().style.cursor = "pointer";
    });
    this.map.on("mouseleave", "t-lines", () => {
      this.map.getCanvas().style.cursor = "";
    });
  }

  render() {
    return (
      <div className="App" style={{ width: "100%", height: "100%" }}>
        <div className="mapContainer" style={{ width: "100%", height: "100%" }}>
          <div
            className="mapBox"
            style={{ width: "100%", height: "100%" }}
            ref={(el) => {
              this.container = el;
            }}
          />
        </div>
      </div>
    );
  }
}

export { Map };
